import { useParams } from "react-router-dom";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	setSessionPage,
	setSessionFilter,
	saveFilter,
	deleteFilters,
} from "../../../redux/actions/user-action-types";
import {
	xhrClinicalSearchExamRef,
	ClinicalSearchExamDataFromFilter,
} from "../../../utilities/xhr-clinical";
import { Tag } from "antd";
import Calendericon from "../../../assets/icons/calender.png";
import DateRangePickerContainer from "./DateRangePicker";
import ExamBottomSection from "../../../components/ExamBottomSection";
import ExamRefListRecord from "../../../components/ExamRefListRecord";
import CustomMultiSelect from "../../../components/base/CustomMultiSelect";
import MyLoader from "./Loader";
import { Modal, Select } from "antd";
import translator from "../../../utilities/translator";
import { xhrInstGetInstitutionAll } from "../../../utilities/xhr-inst";
import { UpdateUserPreferences } from "../../../redux/actions/account-action-types";
import { toastUtil, toastUtilText } from "../../../utilities/toast-util";
import {
	xhrTenantGetTenantAll,
	xhrTenantGetDoctorsByInstitutionIds,
	xhrTenantGetReferringEntityAll,
} from "../../../utilities/xhr-tenant";

const ExamRefListPage = () => {
	const params = useParams();
	const dispatch = useDispatch();
	const token = useSelector((state) => state.session.token);

	const currentLanguage = useSelector(
		(state) => state.session.userPreferences?.language
	);
	const userPermissions = useSelector((state) => state.session.userPermissions);
	const [useTempPatient, setUseTempPatient] = React.useState(
		new URLSearchParams(window.location.search).get("sid")
	);

	const filtersList = useSelector((state) => state.session.filtersList);
	const sessionFilter = useSelector((state) => state.session.sessionFilter);
	const [examListRecordCount, setExamListRecordCount] = React.useState([]);
	const [examList, setExamList] = React.useState([]);
	const [examListLoading, setExamListLoading] = React.useState(false);

	const userInfo = useSelector((state) => state.session.userInfo);

	const userPreferences = useSelector(
		(state) => state?.session?.userPreferences
	);
	const [activeFilter, setActiveFilter] = React.useState(null);

	const [tenantList, setTenantList] = React.useState();
	const [conditionsList, setConditionsList] = React.useState([
		{
			id: 0,
			value:
				String(translator(currentLanguage, "with")).capitalizeFirstLetter() +
				" " +
				translator(currentLanguage, "images"),
			selected: false,
		},
		{
			id: 2,
			value:
				String(translator(currentLanguage, "with")).capitalizeFirstLetter() +
				" " +
				translator(currentLanguage, "text"),
			selected: false,
		},
		{
			id: 4,
			value:
				String(translator(currentLanguage, "without")).capitalizeFirstLetter() +
				" " +
				translator(currentLanguage, "images"),
			selected: false,
		},
		{
			id: 6,
			value:
				String(translator(currentLanguage, "without")).capitalizeFirstLetter() +
				" " +
				translator(currentLanguage, "text"),
			selected: false,
		},
	]);

	React.useEffect(() => {
		if (sessionFilter?.dts > -10000) {
			searchExamFn(sessionFilter, 0);
		}
	}, [sessionFilter?.dts]);

	React.useEffect(() => {
		dispatch(setSessionPage({ sessionPage: "/exam-ref-list" }));
	}, []);

	React.useEffect(() => {
		if (!sessionFilter?.srt || !sessionFilter?.srd) {
			const defaultFilter = {
				...sessionFilter,
				srt: "Date",
				srd: "desc",
			};
			dispatch(setSessionFilter({ sessionFilter: defaultFilter }));
			setPageIndex(0);
			searchExamFn(defaultFilter, 0);
		}
	}, []);

	React.useEffect(() => {
		let mountedRef = true;
		if (userInfo?.id) {
			const effectPromise = async () => {
				var data = await xhrTenantGetTenantAll(token);
				toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;
				setTenantList(data?.result?.data ?? []);
			};
			effectPromise();
		}
		return () => {
			mountedRef = false;
		};
	}, [userInfo?.id]);

	const [allRefEntList, setAllRefEntList] = React.useState([]);
	const [refEntFilter, setRefEntFilter] = React.useState("");

	React.useEffect(() => {
		let mountedRef = true;
		if (userInfo?.id) {
			const effectPromise = async () => {
				var parms = { pr: 100 };
				if (refEntFilter?.length > 0) {
					parms.flt = { name: refEntFilter };
				}
				var data = await xhrTenantGetReferringEntityAll(token, parms);
				toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;
				setAllRefEntList(data?.result?.data ?? []);
			};
			effectPromise();
		}
		return () => {
			mountedRef = false;
		};
	}, [userInfo?.id, refEntFilter]);

	const onSearchRefEnt = (text) => {
		onSelectRefEnt([]);
		setRefEntFilter(text);
	};

	const [allInstitutionList, setAllInstitutionList] = React.useState([]);

	React.useEffect(() => {
		let mountedRef = true;
		if (userInfo?.id) {
			const effectPromise = async () => {
				var data = await xhrInstGetInstitutionAll(token);
				toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;
				setAllInstitutionList(data?.result?.data ?? []);
			};
			effectPromise();
		}
		return () => {
			mountedRef = false;
		};
	}, [userInfo?.id]);

	React.useEffect(() => {
		const filter = filtersList?.find(
			(x) =>
				(x.nm === userPreferences?.examListFilter &&
					sessionFilter?.nm === "<#Initial#>") ||
				x.nm === sessionFilter?.nm
		);
		if (filter) {
			sessionFilter.t = filter.t ?? [];
			sessionFilter.i = filter.i ?? [];
			sessionFilter.rf = filter.rf ?? [];
			sessionFilter.m = filter.m ?? [];
			sessionFilter.es = filter.es ?? [];
			sessionFilter.sn = filter.sn ?? "";
			sessionFilter.si = filter.si ?? "";
			sessionFilter.o = filter.o ?? true;
			sessionFilter.ute = filter.ute ?? null;
			sessionFilter.ura = filter.ura ?? null;
			sessionFilter.uty = filter.uty ?? null;
			sessionFilter.dr = filter.dr ?? "1D";
			sessionFilter.srd = filter.srd ?? "Date";
			sessionFilter.srt = filter.srt ?? "asc";
			sessionFilter.nm = filter.nm ?? "";
			sessionFilter.edt = filter.edt ?? "";
			sessionFilter.sdt = filter.sdt ?? "";
			sessionFilter.himg = filter.himg;
			sessionFilter.haud = filter.haud;
			sessionFilter.htxt = filter.htxt;
			sessionFilter.hreq = filter.hreq;

			dispatch(setSessionFilter({ sessionFilter: sessionFilter }));
			searchExamFn(sessionFilter, 0);
		}
	}, [filtersList, userPreferences?.examListFilter, sessionFilter?.nm]);

	const [patientId, setPatientId] = React.useState(useTempPatient);
	const [patientName, setPatientName] = React.useState(null);
	const [pageIndex, setPageIndex] = React.useState(0);
	const pageRecord = 30;
	const [selectedExam, setSelectedExam] = React.useState(null);
	const [selectedExamSecondary, setSelectedExamSecondary] = React.useState([]);
	const [showDateRangePicker, setShowDateRangePicker] = React.useState(false);

	const setSelectedExamFn = (exam, isSecondary) => {
		setSelectedExam(exam);
	};

	const [radUserList, setRadUserList] = React.useState([]);

	const newInsList = React.useMemo(() => {
		let whichInst = [];
		if (allInstitutionList?.length > 0) {
			if (sessionFilter.i?.length > 0) {
				whichInst = whichInst.concat(sessionFilter.i);
			} else {
				whichInst = whichInst.concat(
					(sessionFilter?.t.length > 0
						? allInstitutionList?.filter((x) =>
								sessionFilter?.t.includes(x.tenantId)
						  )
						: allInstitutionList
					)?.map((x) => x.id)
				);
			}
		}

		//clean duplicates
		let newInsList = whichInst.filter((v, i, a) => a.indexOf(v) === i);
		return newInsList;
	}, [
		sessionFilter.m,
		sessionFilter.i,
		sessionFilter.es,
		sessionFilter?.t,
		allInstitutionList,
	]);

	React.useEffect(() => {
		let mountedRef = true;

		const effectPromise = async () => {
			if (allInstitutionList?.length > 0) {
				onSearchRadUser("");
			}
		};
		effectPromise();
		return () => {
			mountedRef = false;
		};
	}, [allInstitutionList, newInsList]);

	const onSearchRadUser = React.useCallback(
		async (text) => {
			var data = {};
			if (newInsList?.length > 0) {
				data.ids = newInsList;
			} else {
				if (allInstitutionList?.length > 0) {
					data.ids = allInstitutionList.map((e) => e.id);
				}
			}
			if (text?.length > 0) {
				data.flt =
					text?.length > 0 ? "UserDisplayName=" + text?.toUpperCase() : "";
			}

			var dataTec = await xhrTenantGetDoctorsByInstitutionIds(token, data);
			toastUtil({ currentLanguage, data: dataTec });

			if (dataTec?.result?.data?.length > 0) {
				setRadUserList(
					dataTec?.result?.data.sort((a, b) =>
						a.userDisplayName < b.userDisplayName ? -1 : 1
					)
				);
			}
		},
		[token, currentLanguage, allInstitutionList, newInsList]
	);

	React.useEffect(() => {
		onSearchRadUser("");
	}, [newInsList, allInstitutionList]);

	const [TEMP_startDateString, setTEMP_startDateString] = React.useState("");
	const [TEMP_endDateString, setTEMP_endDateString] = React.useState("");

	const onSelectTenant = (selectedList, selectedItem) => {
		const tenantIdArr = [];
		const institutionIdArr = [];

		for (let i = 0; i < selectedList.length; i++) {
			tenantIdArr.push(selectedList[i].id);
			for (
				let filinst = 0;
				filinst < sessionFilter?.i?.length ?? 0;
				filinst++
			) {
				for (let inst = 0; inst < allInstitutionList.length; inst++) {
					if (
						allInstitutionList[inst].tenantId === selectedList[i].id &&
						sessionFilter.i[filinst] === allInstitutionList[inst]
					) {
						institutionIdArr.push(allInstitutionList[inst].id);
					}
				}
			}
		}
		sessionFilter.t = tenantIdArr ?? [];
		sessionFilter.i = institutionIdArr ?? [];
		/*let instList = allInstitutionList;
		if(sessionFilter?.t.length > 0){
			instList = allInstitutionList.filter((x) => sessionFilter?.t.includes(x.tenantId));
			
		}
		setInstitutionList(instList);*/
		sessionFilter.nm = "";
		dispatch(setSessionFilter({ sessionFilter: sessionFilter }));
		setActiveFilter("");
		setPageIndex(0);
		searchExamFn(sessionFilter, 0);
	};

	const onSelectInstitution = (selectedList, selectedItem) => {
		const institutionIdArr = [];
		for (let i = 0; i < selectedList.length; i++) {
			institutionIdArr.push(selectedList[i].id);
		}
		sessionFilter.i = institutionIdArr ?? [];
		sessionFilter.nm = "";
		dispatch(setSessionFilter({ sessionFilter: sessionFilter }));
		setActiveFilter("");
		setPageIndex(0);
		searchExamFn(sessionFilter, 0);
	};

	const onSelectRefEnt = (selectedList, selectedItem) => {
		const institutionIdArr = [];
		for (let i = 0; i < selectedList.length; i++) {
			institutionIdArr.push(selectedList[i].id);
		}
		sessionFilter.rf = institutionIdArr ?? [];
		sessionFilter.nm = "";
		dispatch(setSessionFilter({ sessionFilter: sessionFilter }));
		setActiveFilter("");
		setPageIndex(0);
		searchExamFn(sessionFilter, 0);
	};

	const onSelectRadUser = (selectedList, selectedItem) => {
		sessionFilter.ura = null;
		if (selectedList?.length > 0) {
			for (let i = selectedList.length - 1; i < selectedList.length; i++) {
				sessionFilter.ura = selectedList[i].id;
			}
		}
		sessionFilter.nm = "";
		dispatch(setSessionFilter({ sessionFilter: sessionFilter }));
		setActiveFilter("");
		setPageIndex(0);
		searchExamFn(sessionFilter, 0);
	};

	const onCheckedExamStatus = (e) => {
		const currentValue = parseInt(e.target.name);
		const index = sessionFilter?.es?.findIndex((x) => x === currentValue);
		if (e.target.checked) {
			if (index === -1) {
				sessionFilter.es = [...sessionFilter?.es, currentValue];
			}
		} else {
			if (index !== -1) {
				sessionFilter.es = sessionFilter?.es?.filter((x) => x !== currentValue);
			}
		}
		sessionFilter.nm = "";
		dispatch(setSessionFilter({ sessionFilter: sessionFilter }));
		setActiveFilter("");
		setPageIndex(0);
		searchExamFn(sessionFilter, 0);
	};

	const onCheckModalities = (e) => {
		const currentValue = e.target.id;
		const index = sessionFilter?.m.findIndex((x) => x === currentValue);

		if (e.target.checked) {
			if (index === -1) {
				sessionFilter.m = [...sessionFilter?.m, currentValue];
			}
		} else {
			if (index !== -1) {
				sessionFilter.m = sessionFilter?.m?.filter((x) => x !== currentValue);
			}
		}
		sessionFilter.nm = "";
		dispatch(setSessionFilter({ sessionFilter: sessionFilter }));
		setActiveFilter("");
		setPageIndex(0);
		searchExamFn(sessionFilter, 0);
	};

	const handleChange = (e) => {
		e?.preventDefault();
		const { value, id } = e.target;
		if (id === "name") {
			setPatientName(value);
		} else {
			setPatientId(value);
		}
	};

	const handleTextFilter = (e) => {
		if (sessionFilter.si !== patientId || sessionFilter.sn !== patientName) {
			sessionFilter.si = patientId;
			sessionFilter.sn = patientName;
			sessionFilter.nm = "";
			dispatch(setSessionFilter({ sessionFilter: sessionFilter }));
		}
		setActiveFilter("");
		setPageIndex(0);
		searchExamFn(sessionFilter, 0);
	};

	const dateFilter = (e, value, type, category) => {
		e?.preventDefault();

		if (`${value}${category}` !== sessionFilter.dr) {
			sessionFilter.dts = 0;
			sessionFilter.dr = `${value}${category}`;
			sessionFilter.nm = "";
			dispatch(setSessionFilter({ sessionFilter: sessionFilter }));
			setActiveFilter("");
			setPageIndex(0);
			searchExamFn(sessionFilter, 0);
		}
	};

	const conditionsFilter = (selectedList, selectedItem) => {
		for (let i = 0; i < conditionsList.length; i++) {
			if (selectedItem.id === conditionsList[i].id) {
				conditionsList[i].selected = !conditionsList[i].selected;
				switch (conditionsList[i].id) {
					case 0:
						conditionsList[4].selected = false;
						sessionFilter.himg = conditionsList[i].selected ? true : null;
						break;
					case 1:
						conditionsList[5].selected = false;
						sessionFilter.haud = conditionsList[i].selected ? true : null;
						break;
					case 2:
						conditionsList[6].selected = false;
						sessionFilter.htxt = conditionsList[i].selected ? true : null;
						break;
					case 3:
						conditionsList[7].selected = false;
						sessionFilter.hreq = conditionsList[i].selected ? true : null;
						break;
					case 4:
						conditionsList[0].selected = false;
						sessionFilter.himg = conditionsList[i].selected ? false : null;
						break;
					case 5:
						conditionsList[1].selected = false;
						sessionFilter.haud = conditionsList[i].selected ? false : null;
						break;
					case 6:
						conditionsList[2].selected = false;
						sessionFilter.htxt = conditionsList[i].selected ? false : null;
						break;
					case 7:
						conditionsList[3].selected = false;
						sessionFilter.hreq = conditionsList[i].selected ? false : null;
						break;
					default:
						break;
				}
			}
		}
		setConditionsList(conditionsList);
		sessionFilter.nm = "";
		dispatch(setSessionFilter({ sessionFilter: sessionFilter }));
		setActiveFilter("");
		setPageIndex(0);
		searchExamFn(sessionFilter, 0);
	};

	const saveFilterUser = (e) => {
		e?.preventDefault();
		let data = {
			userId: userInfo.id,
		};

		let save = false;

		if (sessionFilter?.t && sessionFilter?.t.length > 0) {
			data = { ...data, t: sessionFilter?.t };
			save = true;
		}
		if (sessionFilter?.i && sessionFilter?.i.length > 0) {
			data = { ...data, i: sessionFilter?.i };
			save = true;
		}
		if (sessionFilter?.si && sessionFilter?.si.length > 0) {
			data = { ...data, si: sessionFilter?.si };
			save = true;
		}
		if (sessionFilter?.sn && sessionFilter?.sn.length > 0) {
			data = { ...data, sn: sessionFilter?.sn };
			save = true;
		}
		if (sessionFilter?.srd && sessionFilter?.srd.length > 0) {
			data = { ...data, srd: sessionFilter?.srd };
			save = true;
		}
		if (sessionFilter?.srt && sessionFilter?.srt.length > 0) {
			data = { ...data, srt: sessionFilter?.srt };
			save = true;
		}
		if (sessionFilter?.himg === true || sessionFilter?.himg === false) {
			data = { ...data, himg: sessionFilter?.himg };
			save = true;
		}
		if (sessionFilter?.haud === true || sessionFilter?.haud === false) {
			data = { ...data, haud: sessionFilter?.haud };
			save = true;
		}
		if (sessionFilter?.htxt === true || sessionFilter?.htxt === false) {
			data = { ...data, htxt: sessionFilter?.htxt };
			save = true;
		}
		if (sessionFilter?.hreq === true || sessionFilter?.hreq === false) {
			data = { ...data, hreq: sessionFilter?.hreq };
			save = true;
		}
		if (sessionFilter?.ute > 0) {
			data = { ...data, ute: sessionFilter?.ute };
			save = true;
		}
		if (sessionFilter?.ura > 0) {
			data = { ...data, ura: sessionFilter?.ura };
			save = true;
		}
		if (sessionFilter?.uty > 0) {
			data = { ...data, uty: sessionFilter?.uty };
			save = true;
		}
		if (sessionFilter?.si && sessionFilter?.si.length > 0) {
			data = { ...data, si: sessionFilter?.si };
			save = true;
		}
		let existingFilter = filtersList.filter((x) => {
			return (
				x?.m?.length === sessionFilter?.m?.length &&
				x?.m?.every((v, i) => v === sessionFilter?.m[i]) &&
				x?.es?.length === sessionFilter?.es?.length &&
				x?.es?.every((v, i) => v === sessionFilter?.es[i]) &&
				x?.dr === sessionFilter?.dr
			);
		});

		sessionFilter.id = existingFilter?.id;

		if (sessionFilter?.nm && sessionFilter?.nm.length > 0) {
			data = { ...data, nm: sessionFilter?.nm };
			save = true;
		}
		if (sessionFilter?.m && sessionFilter?.m.length > 0) {
			data = { ...data, m: sessionFilter?.m };
			save = true;
		}
		if (sessionFilter?.es && sessionFilter?.es.length > 0) {
			data = { ...data, es: sessionFilter?.es };
			save = true;
		}
		if (
			sessionFilter?.dr &&
			sessionFilter?.dr.length > 0 &&
			sessionFilter?.dr !== "custom"
		) {
			data = { ...data, dr: sessionFilter?.dr };
			save = true;
		}
		if (save) {
			dispatch(
				saveFilter({
					data: data,
					callback: (data) => {
						toastUtil({ currentLanguage, data });
					},
				})
			);
		}
	};

	const filterDelete = (id) => {
		dispatch(
			deleteFilters({
				data: id,
				callback: (data) => {
					toastUtil({ currentLanguage, data });
				},
			})
		);
	};

	const resetDateSortingFilter = (e) => {
		e?.preventDefault();

		sessionFilter.srd = "date";
		sessionFilter.srt = "desc";
		sessionFilter.nm = "";
		dispatch(setSessionFilter({ sessionFilter: sessionFilter }));
		setActiveFilter("");
		setPageIndex(0);
		searchExamFn(sessionFilter, 0);
	};

	const resetAllFilters = (e) => {
		e?.preventDefault();
		for (let i = 0; i < conditionsList.length; i++) {
			conditionsList[i].selected = false;
		}
		setConditionsList(conditionsList);

		let data = {
			t: [],
			nm: "",
			i: [],
			m: [],
			es: [],
			dr: "1M",
			sn: "",
			si: "",
			srt: "Date",
			srd: "desc",
			sdt: "",
			edt: "",
			o: true,
			u: null,
			himg: null,
			haud: null,
			htxt: null,
			hreq: null,
			dts: 0,
		};
		dispatch(setSessionFilter({ sessionFilter: data }));
		setPatientId("");
		setPatientName("");
		setActiveFilter("");
		setPageIndex(0);
		searchExamFn(data, 0);
	};

	const searchExamFn = async (paramFilter, paramPage) => {
		let filterObj = paramFilter ?? sessionFilter;
		let pageNumber = paramPage ?? pageIndex;

		//dont add to final array, no need to read updated values
		if (useTempPatient?.length > 0) {
			filterObj.si = useTempPatient ?? "";
			setUseTempPatient("");
		}
		let paramObj = ClinicalSearchExamDataFromFilter(
			filterObj,
			pageNumber,
			pageRecord
		);

		setExamListLoading(true);

		var data = await xhrClinicalSearchExamRef(token, paramObj);
		toastUtil({ currentLanguage, data });
		setExamListLoading(false);
		if (data?.result?.data) {
			if (pageNumber > 0) {
				setExamList(examList.concat(data?.result?.data));
			} else {
				setExamList(data?.result?.data);
				setSelectedExam(null);
				setSelectedExamSecondary([]);
			}
			setExamListRecordCount(data?.result?.recordCount);
		}
	};

	React.useEffect(() => {
		if (userInfo?.id) {
			searchExamFn();
		}
	}, [userInfo?.id]);

	React.useEffect(() => {
		const incPage = () => {
			if (examListLoading) {
				return;
			}
			if (examListRecordCount > examList?.length) {
				searchExamFn(sessionFilter, pageIndex + 1);
				setPageIndex((page) => page + 1);
			}
		};

		const handleScroll = (e) => {
			let element = e.target;
			if (
				element.scrollHeight <=
				element.clientHeight + element.scrollTop + 1
			) {
				incPage();
			}
		};
		const paginatorEl = document.querySelector("#paginator");
		paginatorEl?.addEventListener("scroll", handleScroll);
		return () => paginatorEl?.removeEventListener("scroll", handleScroll);
	}, [examList, examListLoading, examListRecordCount]);

	if (!userPermissions) return null;

	if (!sessionFilter?.srt) sessionFilter.srt = "Date";
	if (!sessionFilter?.srd) sessionFilter.srd = "desc";

	return (
		<div
			className=""
			style={{ height: "100%", paddingTop: "5px", paddingBottom: "5px" }}
		>
			<div
				className="col-md-12 exam-left pr-0"
				style={{
					display: "flex",
					flexDirection: "column",
					width: "calc(100% - 18em)",
					float: "left",
					height: "100%",
				}}
			>
				<div
					className="table-full-width table-tasks table-res custom-scroll exam-table table-border"
					style={{
						height: "calc(100% - " + (selectedExam ? "40px)" : "0px)"),
						paddingLeft: "8px",
						overflow: "auto",
						paddingRight: "8px",
					}}
				>
					<table
						className="table fav-list-table  table-headingfix"
						style={{
							display: "flex",
							flexDirection: "column",
							height: "100%",
							borderCollapse: "separate",
							borderSpacing: "0 3px",
							minWidth: "1050px",
							pointerEvents: examListLoading ? "none" : "auto",
							opacity: examListLoading ? "0.5" : "1",
						}}
					>
						<thead className="bg-customdark">
							<tr>
								<th width="90px">
									<button
										className="btn font-sfpro bg-transparent primary-color font-14 p-0 capital"
										onClick={resetDateSortingFilter}
									>
										{translator(currentLanguage, "reset")}
									</button>
								</th>
								<th width="90px">
									<button
										className="btn font-sfpro bg-transparent text-white font-14 mr-2 capital"
										onClick={async (e) => {
											e && e?.preventDefault();

											sessionFilter.srt = "Date";
											sessionFilter.srd =
												sessionFilter?.srd === "asc" ? "desc" : "asc";
											sessionFilter.nm = "";
											dispatch(
												setSessionFilter({ sessionFilter: sessionFilter })
											);
											setActiveFilter("");
											setPageIndex(0);
											searchExamFn(sessionFilter, 0);
										}}
									>
										{translator(currentLanguage, "date")}
										<i
											className={
												"fa fa-long-arrow-down ml-1 " +
												(sessionFilter.srt === "Date" &&
												sessionFilter?.srd === "desc"
													? "primary-color"
													: "")
											}
											aria-hidden="true"
										></i>
										<i
											className={
												"fa fa-long-arrow-up " +
												(sessionFilter.srt === "Date" &&
												sessionFilter?.srd === "asc"
													? "primary-color"
													: "")
											}
											aria-hidden="true"
										></i>
									</button>
								</th>
								<th width=""> &nbsp; </th>
								<th width=""> &nbsp; </th>
							</tr>
						</thead>
						<tbody id="paginator" className="custom-scroll">
							{examList?.length > 0 ? (
								<>
									{examList?.map((exam, index) => (
										<React.Fragment key={`exam-wrap-${index}`}>
											<ExamRefListRecord
												highlightId={sessionFilter?.si}
												highlightName={sessionFilter?.sn}
												exam={exam}
												index={index}
												isSelected={selectedExam?.id === exam?.id}
												setSelectedExam={setSelectedExamFn}
											/>
										</React.Fragment>
									))}
									{examListLoading && (
										<tr>
											<td colSpan={6}>
												<MyLoader />
											</td>
										</tr>
									)}
								</>
							) : examList?.length === 0 && !examListLoading ? (
								<tr>
									<td colSpan={6}>
										<h3 className="noExamFound">
											{translator(currentLanguage, "exam")}s Found
										</h3>
									</td>
								</tr>
							) : (
								<tr>
									<td colSpan={6}>
										<MyLoader />
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
				{selectedExam && (
					<ExamBottomSection
						examList={examList}
						selectedExam={selectedExam}
						bundledExams={[selectedExam].concat(selectedExamSecondary)}
					/>
				)}
			</div>

			<div
				className=""
				style={{
					display: "flex",
					flexDirection: "column",
					width: "18em",
					float: "left",
					height: "100%",
				}}
			>
				<div className="">
					<div
						className="d-flex flex-row bg-customdark justify-content-between align-items-center"
						style={{
							padding: "0.0rem 0.5rem",
							minHeight: "36px",
						}}
					>
						<div className="">
							<button
								className="btn font-sfpro bg-transparent primary-color p-0 font-14 capital"
								onClick={resetAllFilters}
							>
								{translator(currentLanguage, "reset")}
							</button>
						</div>
					</div>
				</div>
				<div
					className=""
					style={{
						flex: "1",
						backgroundColor: "#fff",
						overflow: "auto",
						fontSize: "14px",
						pointerEvents: examListLoading ? "none" : "auto",
						opacity: examListLoading ? "0.5" : "1",
					}}
				>
					<div>
						<div className="card border-0">
							<div
								className="col-12 card-body margin-sticky"
								style={{ paddingTop: "3px" }}
							>
								<div className="form-group row mb-0">
									<div className="col-lg-12 col-md-12">
										{tenantList?.length > 1 && (
											<div
												className="select-wrap"
												style={{ marginBottom: "0.5em" }}
											>
												<CustomMultiSelect
													style={{ fontSize: "smaller" }}
													id={"select_tenant"}
													options={tenantList?.sort((a, b) =>
														a?.code?.localeCompare(b?.code)
													)}
													showCheckbox
													disabled={examListLoading ? "disabled" : undefined}
													onSelect={onSelectTenant}
													onRemove={onSelectTenant}
													displayValue="code"
													placeholder={translator(
														currentLanguage,
														"select_tenant"
													)}
													closeIcon="cancel"
													selectedValues={tenantList.filter((x) =>
														(sessionFilter?.t ?? []).includes(x.id)
													)}
												/>
											</div>
										)}
										{allInstitutionList?.length > 1 && (
											<div
												className="select-wrap"
												style={{ marginBottom: "0.5em" }}
											>
												<CustomMultiSelect
													style={{ fontSize: "smaller" }}
													id={"select_institution"}
													options={(sessionFilter?.t.length > 0
														? allInstitutionList.filter((x) =>
																sessionFilter?.t.includes(x.tenantId)
														  )
														: allInstitutionList
													)?.sort((a, b) => a?.code?.localeCompare(b?.code))}
													showCheckbox
													disabled={examListLoading ? "disabled" : undefined}
													onSelect={onSelectInstitution}
													onRemove={onSelectInstitution}
													displayValue="code"
													placeholder={translator(
														currentLanguage,
														"select_institution"
													)}
													closeIcon="cancel"
													selectedValues={(sessionFilter?.t.length > 0
														? allInstitutionList.filter((x) =>
																sessionFilter?.t.includes(x.tenantId)
														  )
														: allInstitutionList
													).filter((x) =>
														(sessionFilter?.i ?? []).includes(x.id)
													)}
												/>
											</div>
										)}
										{
											<div
												className="select-wrap"
												style={{ marginBottom: "0.5em" }}
											>
												<CustomMultiSelect
													style={{ fontSize: "smaller" }}
													id={"select_ref_ent"}
													options={(sessionFilter?.t.length > 0
														? allRefEntList.filter((x) =>
																sessionFilter?.t.includes(x.tenantId)
														  )
														: allRefEntList
													)?.sort((a, b) => a?.code?.localeCompare(b?.code))}
													showCheckbox
													disabled={examListLoading ? "disabled" : undefined}
													onSelect={onSelectRefEnt}
													onSearch={onSearchRefEnt}
													onRemove={onSelectRefEnt}
													displayValue="name"
													placeholder={translator(
														currentLanguage,
														"select_ref_ent"
													)}
													closeIcon="cancel"
													selectedValues={(sessionFilter?.t.length > 0
														? allRefEntList.filter((x) =>
																sessionFilter?.t.includes(x.tenantId)
														  )
														: allRefEntList
													).filter((x) =>
														(sessionFilter?.rf ?? []).includes(x.id)
													)}
												/>
											</div>
										}
										{radUserList?.length > 0 && (
											<div
												className="select-wrap"
												style={{ marginBottom: "0.5em" }}
											>
												<CustomMultiSelect
													style={{ fontSize: "smaller" }}
													id={"select_rad_user"}
													showCheckbox
													hidePlaceholder={true}
													options={radUserList?.sort((a, b) =>
														a?.userDisplayName?.localeCompare(
															b?.userDisplayName
														)
													)}
													disabled={examListLoading ? "disabled" : undefined}
													onSelect={onSelectRadUser}
													onRemove={onSelectRadUser}
													displayValue="userDisplayName"
													placeholder={translator(
														currentLanguage,
														"select_rad_user"
													)}
													closeIcon="cancel"
													selectedValues={radUserList.filter(
														(x) => x.id === sessionFilter?.ura
													)}
												/>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>

						<div className=" card border-0 ">
							<div className="card-header bg-transparent">
								<h4 className="w-100 card-title d-flex justify-content-between capital">
									{translator(currentLanguage, "search")}
								</h4>
							</div>
							<div className="col-12 card-body">
								<div className="col-lg-12 col-md-12" style={{}}>
									<div className="select-wrap capital">
										<CustomMultiSelect
											style={{ fontSize: "smaller" }}
											id={"select_condittion"}
											options={conditionsList}
											showCheckbox
											disabled={examListLoading ? "disabled" : undefined}
											onSelect={conditionsFilter}
											onRemove={conditionsFilter}
											displayValue="value"
											placeholder={translator(currentLanguage, "conditions")}
											closeIcon="cancel"
											selectedValues={conditionsList.filter((x) => x.selected)}
										/>
									</div>
								</div>
								<div className="form-group row mb-0 py-2">
									<div
										className="col-lg-12 col-md-12"
										style={{ marginBottom: "0.5em" }}
									>
										<input
											className="form-control w-100 "
											type="text"
											name=""
											disabled={examListLoading ? "disabled" : undefined}
											id="name"
											placeholder={translator(currentLanguage, "search_name")}
											value={patientName ?? sessionFilter.sn}
											onChange={handleChange}
											onBlur={handleTextFilter}
											onKeyDown={(e) => {
												if (e.key === "Enter") {
													handleTextFilter();
												}
											}}
										/>
									</div>
									<div className="col-lg-12 col-md-12">
										<input
											className="form-control w-100"
											type="text"
											name=""
											disabled={examListLoading ? "disabled" : undefined}
											id="id"
											placeholder={translator(currentLanguage, "search_id")}
											value={patientId ?? sessionFilter.si}
											onChange={handleChange}
											onBlur={handleTextFilter}
											onKeyDown={(e) => {
												if (e.key === "Enter") {
													handleTextFilter();
												}
											}}
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="card border-0">
							<div className="card-header bg-transparent">
								<h4 className="w-100 card-title d-flex justify-content-between capital">
									{translator(currentLanguage, "modalities")}
								</h4>
							</div>
							<div className="col-12 card-body modalities">
								<div
									className="d-flex flex-wrap justify-content-start"
									style={{
										gap: "8px 10px", // espaço horizontal (10px) e vertical (8px)
										rowGap: "8px", // compatibilidade extra
									}}
								>
									{[
										"CR",
										"CT",
										"DX",
										"MG",
										"MR",
										"OT",
										"PX",
										"RF",
										"SC",
										"US",
										"XA",
										"ST",
										"BMD",
										"DOC",
										"ECG",
										"EPS",
										"IOL",
									].map((mod) => {
										const active = sessionFilter?.m?.includes(mod);
										return (
											<Tag.CheckableTag
												key={mod}
												checked={active}
												onChange={(checked) => {
													const modEvent = { target: { id: mod, checked } };
													onCheckModalities(modEvent);
												}}
												style={{
													width: "30px",
													textAlign: "center",
													borderRadius: "5px",
													padding: "3px 0",
													fontWeight: 600,
													fontSize: "11px",
													background: active
														? "linear-gradient(90deg, #E78E4A, #C16427)"
														: "#f5f5f5",
													color: active ? "#fff" : "#333",
													border: "none",
													transition: "all 0.25s ease",
													boxShadow: active
														? "0 2px 6px rgba(231,142,74,0.35)"
														: "none",
													cursor: examListLoading ? "not-allowed" : "pointer",
													opacity: examListLoading ? 0.6 : 1,
												}}
											>
												{mod}
											</Tag.CheckableTag>
										);
									})}
								</div>
							</div>
						</div>

						<div className="card border-0 sidebar-dates">
							<div className="card-header bg-transparent d-flex flex-row">
								<h4 className="w-100 card-title d-flex justify-content-between capital">
									{translator(currentLanguage, "date")}

									{sessionFilter.dts != 0 && (
										<div style={{ fontSize: "small", color: "lightgray" }}>
											({sessionFilter.dts})
										</div>
									)}
								</h4>
							</div>
							<div
								className="col-12 card-body pb-0"
								style={{ display: "flex", flexDirection: "row" }}
							>
								<div style={{}}>
									<i
										className="zmdi zmdi-chevron-left"
										style={{
											background: sessionFilter.dts < 0 ? "orange" : "#f5f5f5",
											border: "1px solid #d6d6d6",
											fontWeight: "900",
											padding: "1.3em 4px",
											borderRadius: "4px 0 0 4px",
											cursor: "pointer",
										}}
										onClick={async (e) => {
											e?.preventDefault();
											setPageIndex(0);
											sessionFilter.dts = (sessionFilter.dts ?? 0) - 1;
											dispatch(
												setSessionFilter({ sessionFilter: sessionFilter })
											);
											searchExamFn(sessionFilter, 0);
										}}
									></i>
								</div>
								<div className="row toggle_radio toggle_radio_dates">
									<div className="col-lg-4 col-sm-4">
										<input
											type="checkbox"
											className="toggle_option d-none"
											id="1D"
											disabled={examListLoading ? "disabled" : undefined}
											checked={
												sessionFilter?.dr === `1D` ? "checked" : "unchecked"
											}
											onChange={async (e) => dateFilter(e, 1, "days", "D")}
										/>
										<label
											htmlFor="1D"
											style={
												sessionFilter?.dr === `1D`
													? {
															background: "#e78e49",
															color: "#ffffff",
													  }
													: {}
											}
										>
											1D
										</label>
									</div>
									<div className="col-lg-4 col-sm-4">
										<input
											type="checkbox"
											className="toggle_option d-none"
											id="15D"
											disabled={examListLoading ? "disabled" : undefined}
											checked={
												sessionFilter?.dr === `15D` ? "checked" : "unchecked"
											}
											onChange={async (e) => dateFilter(e, 15, "days", "D")}
										/>
										<label
											htmlFor="15D"
											style={
												sessionFilter?.dr === `15D`
													? {
															background: "#e78e49",
															color: "#ffffff",
													  }
													: {}
											}
										>
											15D
										</label>
									</div>
									<div className="col-lg-4 col-sm-4">
										<input
											type="checkbox"
											className="toggle_option d-none"
											id="1M"
											disabled={examListLoading ? "disabled" : undefined}
											checked={
												sessionFilter?.dr === `1M` ? "checked" : "unchecked"
											}
											onChange={async (e) => dateFilter(e, 1, "months", "M")}
										/>
										<label
											htmlFor="1M"
											style={
												sessionFilter?.dr === `1M`
													? {
															background: "#e78e49",
															color: "#000",
													  }
													: {}
											}
										>
											1M
										</label>
									</div>
									<div className="col-lg-4 col-sm-4">
										<input
											type="checkbox"
											className="toggle_option d-none"
											id="2M"
											disabled={examListLoading ? "disabled" : undefined}
											checked={
												sessionFilter?.dr === `2M` ? "checked" : "unchecked"
											}
											onChange={async (e) => dateFilter(e, 2, "months", "M")}
										/>
										<label
											htmlFor="2M"
											style={
												sessionFilter?.dr === `2M`
													? {
															background: "#e78e49",
															color: "#ffffff",
													  }
													: {}
											}
										>
											2M
										</label>
									</div>
									<div className="col-lg-4 col-sm-4">
										<input
											type="checkbox"
											className="toggle_option d-none"
											id="4M"
											disabled={examListLoading ? "disabled" : undefined}
											checked={
												sessionFilter?.dr === `4M` ? "checked" : "unchecked"
											}
											onChange={async (e) => dateFilter(e, 4, "months", "M")}
										/>
										<label
											htmlFor="4M"
											style={
												sessionFilter?.dr === `4M`
													? {
															background: "#e78e49",
															color: "#ffffff",
													  }
													: {}
											}
										>
											4M
										</label>
									</div>
									<div className="col-lg-4 col-sm-4">
										<input
											type="checkbox"
											className="toggle_option d-none"
											id="calicon"
											disabled={examListLoading ? "disabled" : undefined}
											name="toggle_option"
											checked={
												sessionFilter?.dr === `custom` ? "checked" : "unchecked"
											}
											onChange={async (e) =>
												setShowDateRangePicker(!showDateRangePicker)
											}
										/>
										<label
											htmlFor="calicon"
											style={
												sessionFilter?.dr === `custom`
													? {
															background: "#e78e49",
															color: "#ffffff",
															padding: "3px 20px",
													  }
													: {
															padding: "3px 20px",
													  }
											}
										>
											<img src={Calendericon} alt="calender icon" />
										</label>
										<Modal
											title={String(
												translator(currentLanguage, "date")
											).capitalizeFirstLetter()}
											open={showDateRangePicker}
											disabled={examListLoading ? "disabled" : undefined}
											className="date-modal"
											onOk={(e) => {
												console.log(e);
												setActiveFilter("");
												setShowDateRangePicker(false);
												sessionFilter.dr = "custom";
												sessionFilter.sdt = TEMP_startDateString;
												sessionFilter.edt = TEMP_endDateString;
												sessionFilter.nm = "";
												dispatch(
													setSessionFilter({ sessionFilter: sessionFilter })
												);
												setPageIndex(0);
												searchExamFn(sessionFilter, 0);
											}}
											onCancel={(e) => {
												console.log(e);
												setShowDateRangePicker(false);
											}}
										>
											<div className="date-picker">
												<DateRangePickerContainer
													disabled={examListLoading ? "disabled" : undefined}
													onDatesChange={({ startDate, endDate }) => {
														console.log({ startDate, endDate });
														if (startDate) {
															const startDateString =
																startDate.toDate().toISOString().slice(0, 10) +
																" 00:00:00";
															setTEMP_startDateString(startDateString);
														}
														if (endDate) {
															const endDateString =
																endDate.toDate().toISOString().slice(0, 10) +
																" 23:59:59";
															setTEMP_endDateString(endDateString);
														}
													}}
												/>
											</div>
										</Modal>
									</div>
								</div>
								<div style={{}}>
									<i
										className="zmdi zmdi-chevron-right"
										style={{
											background: sessionFilter.dts > 0 ? "orange" : "#f5f5f5",
											border: "1px solid #d6d6d6",
											fontWeight: "900",
											padding: "1.3em 4px",
											borderRadius: "0 4px 4px 0",
											cursor: "pointer",
										}}
										onClick={async (e) => {
											e?.preventDefault();
											setPageIndex(0);
											sessionFilter.dts = (sessionFilter.dts ?? 0) + 1;
											dispatch(
												setSessionFilter({ sessionFilter: sessionFilter })
											);
											searchExamFn(sessionFilter, 0);
										}}
									></i>
								</div>
							</div>
						</div>

						<div className="card border-0 sidebar-dates">
							<div className="card-header bg-transparent d-flex flex-row">
								<h4 className="w-100 card-title capital">
									{translator(currentLanguage, "saved")}
								</h4>
							</div>
							<div className="col-12 card-body pb-0">
								<div className="  no-gutters">
									<div className="row toggle_radio m-0">
										{filtersList
											?.sort((a, b) => a?.nm?.localeCompare(b?.nm))
											?.map(({ nm, id }, i) => {
												return (
													<div
														key={`filter-list-${i}`}
														className="toggle-icon"
														disabled={examListLoading ? "disabled" : undefined}
														onClick={async (e) => {
															e?.preventDefault();

															if (activeFilter === nm) {
																resetAllFilters();
															} else {
																setActiveFilter(nm);
																sessionFilter.nm = nm;
																dispatch(
																	setSessionFilter({
																		sessionFilter: sessionFilter,
																	})
																);
																setPageIndex(0);
																searchExamFn(sessionFilter, 0);
															}
														}}
													>
														<input
															type="radio"
															className="toggle_option d-none"
															id={nm}
															checked={sessionFilter?.nm === nm}
															disabled={
																examListLoading ? "disabled" : undefined
															}
															readOnly={true}
															name="toggle_option"
															value={nm}
														/>
														<label
															htmlFor={nm}
															className={
																sessionFilter?.nm === nm
																	? ""
																	: "textlight-black"
															}
															style={
																sessionFilter?.nm === nm
																	? {
																			background: "#e78e49",
																			color: "#ffffff",
																	  }
																	: {}
															}
														>
															{nm}
														</label>
														<i
															className="fa fa-close"
															disabled={
																examListLoading ? "disabled" : undefined
															}
															onClick={async (e) => {
																e.stopPropagation();
																filterDelete(id);
															}}
														/>
														<i
															className="fa fa-star"
															disabled={
																examListLoading ? "disabled" : undefined
															}
															style={{
																left: "0",
																backgroundColor:
																	userPreferences?.examListFilter === nm
																		? "rgb(231, 142, 73)"
																		: "#80808085",
															}}
															onClick={async (e) => {
																e.stopPropagation();
																dispatch(
																	UpdateUserPreferences({
																		data: {
																			examListFilter:
																				userPreferences?.examListFilter === nm
																					? null
																					: nm,
																		},
																	})
																);
																toastUtilText(
																	currentLanguage,
																	"Success",
																	"success"
																);
															}}
														/>
													</div>
												);
											})}
									</div>
								</div>
							</div>
						</div>
						<button
							className="btn btntype-two btn-transparency mt-0 last-sidebarbtn capital"
							style={{
								background: "#e78e49",
								color: "#fff",
								margin: "1rem auto",
							}}
							disabled={examListLoading ? "disabled" : undefined}
							onClick={async (e) => saveFilterUser(e)}
						>
							{translator(currentLanguage, "save")}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ExamRefListPage;
